import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cn as clsx } from "../../helpers/react.js";
import { isFiniteNumber } from "../../helpers/utils.js";
import { Font } from "../Font/index.js";
import { withThemeAndSize } from "../withThemeAndSize/index.js";
import '../../assets/index10.css';const basicBadge = "_basicBadge_16qcd_1";
const noWrap = "_noWrap_16qcd_13";
const numericBadge = "_numericBadge_16qcd_17";
const withPadding = "_withPadding_16qcd_20";
const textBadge = "_textBadge_16qcd_24";
const subdued = "_subdued_16qcd_35";
const critical = "_critical_16qcd_40";
const warning = "_warning_16qcd_45";
const success = "_success_16qcd_50";
const info = "_info_16qcd_55";
const disabled = "_disabled_16qcd_60";
const onColor = "_onColor_16qcd_65";
const s = {
  basicBadge,
  noWrap,
  numericBadge,
  withPadding,
  textBadge,
  "default": "_default_16qcd_30",
  subdued,
  critical,
  warning,
  success,
  info,
  disabled,
  onColor
};
const CLASS_NAME_MAP = {
  default: s.default,
  subdued: s.subdued,
  critical: s.critical,
  warning: s.warning,
  success: s.success,
  info: s.info,
  disabled: s.disabled,
  "on-colour": s.onColor
};
const NumericalBadge = withThemeAndSize(
  forwardRef(({ count, className, badgeColor = "default", disabled: disabled2, children, breakWords = true, ...rest }, ref) => {
    const badgeCount = isFiniteNumber(count) ? Math.round(count) : null;
    let result = "";
    if (badgeCount !== null) {
      result = badgeCount > 99 ? "99+" : `${badgeCount}`;
    } else {
      result = children || "";
    }
    if (!result) {
      return null;
    }
    return /* @__PURE__ */ jsx(Font, { type: "numerical", size: 10, weight: "bold", children: /* @__PURE__ */ jsx(
      "div",
      {
        ...rest,
        className: clsx(
          s.basicBadge,
          s.numericBadge,
          CLASS_NAME_MAP[disabled2 ? "disabled" : badgeColor],
          {
            [s.withPadding]: result.length >= 3,
            [s.noWrap]: !breakWords
          },
          className
        ),
        ref,
        children: result
      }
    ) });
  })
);
const TextBadge = withThemeAndSize(
  forwardRef(({ className, badgeColor = "default", children, disabled: disabled2, breakWords = true, ...rest }, ref) => {
    return /* @__PURE__ */ jsx(Font, { type: "text", size: 12, weight: "medium", children: /* @__PURE__ */ jsx(
      "div",
      {
        ...rest,
        className: clsx(s.basicBadge, s.textBadge, CLASS_NAME_MAP[disabled2 ? "disabled" : badgeColor], className, {
          [s.noWrap]: !breakWords
        }),
        ref,
        children
      }
    ) });
  })
);
export {
  NumericalBadge,
  TextBadge
};
